import React from 'react'
import ImageSkeleton from '../../../components/NFTImageSkeleton'
import { ICryptoSeals } from '../ICryptoSeals'

export interface ICryptoSealImage {
  tokenItem: ICryptoSeals | null
  tokenName: string
}

export default function CryptoSealImage({ tokenItem, tokenName }: ICryptoSealImage) {
  return tokenItem ? (
    <React.Fragment>
      <img className="crypto-seal-bg" src={tokenItem?.image} alt={tokenName} />
      {tokenItem?.character_level && (
        <img
          className="crypto-seal-character"
          src={`https://cryptoseals.art/characters/${tokenItem?.character}/${tokenItem?.character_level}.gif`}
          alt={tokenName}
        />
      )}
    </React.Fragment>
  ) : (
    <ImageSkeleton />
  )
}
